import { GoogleSheet_API_Service } from "../Constants";

const getGoogleConnectionList = (SessionId) => {
    let url = `${GoogleSheet_API_Service.getConnectionList}`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            sessionId: SessionId,
        },
    }).then((response) => response.json());
};

const getGoogleAuthURL = () => {
    let url = `${GoogleSheet_API_Service.getAuthUrl}`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.text());
};

const storeGoogleAuthCode = (code, sessionId) => {
    let url = `${GoogleSheet_API_Service.storeAuthCode}`;
    const model = {};
    model.authCode = code;
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(model),
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.json());
};

const getWorkbookList = (sessionId, gSheetUId) => {
    let url = `${GoogleSheet_API_Service.getWorkbookList}?gSheetUId=${encodeURIComponent(gSheetUId)}`;
    return fetch(url, {
        method: "GET",
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.json());
};

const getWorksheetList = (sessionId, workbookName, gSheetUId) => {
    let url = `${GoogleSheet_API_Service.getWorksheetList}?workbookName=${encodeURIComponent(workbookName)}&gSheetUId=${encodeURIComponent(gSheetUId)}`;
    return fetch(url, {
        method: "GET",
        //body: JSON.stringify({ "workbookName": workbookName }),
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.json());
};

const saveGoogleConnection = (sessionId, workbookName, connectionName, workSheetName, gSheetUId) => {
    let url = `${GoogleSheet_API_Service.saveConnection}`;
    const object = {
        "connectionName": connectionName,
        "workbookName": workbookName,
        "workbookId": "",
        "workSheetName": workSheetName,
        "gSheetUId": gSheetUId
    };

    return fetch(url, {
        method: "Post",
        body: JSON.stringify(object),
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.text());
};

const getGoogleSheetConnectionDetail = (sessionId, sheetName) => {
    let url = `${GoogleSheet_API_Service.getGSheetConnectionDetails}/${encodeURIComponent(sheetName)}`;
    return fetch(url, {
        method: "GET",
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.text());
};


const updateGoogleConnection = (sessionId, connObject) => {
    let url = `${GoogleSheet_API_Service.updateGSheetConnection}`;

    return fetch(url, {
        method: "Post",
        body: JSON.stringify(connObject),
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.text());
};

const deleteGoogleSheetConnection = (sessionId, connectionName) => {
    let url = `${GoogleSheet_API_Service.deleteGSheetConnection}/${encodeURIComponent(connectionName)}`;
    return fetch(url, {
        method: "DELETE",
        headers: {
            sessionId: sessionId,
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((response) => response.text());
};

const GenericGoogleSheetService = {
    getGoogleConnectionList,
    getGoogleAuthURL,
    storeGoogleAuthCode,
    getWorkbookList,
    getWorksheetList,
    saveGoogleConnection,
    getGoogleSheetConnectionDetail,
    updateGoogleConnection,
    deleteGoogleSheetConnection
};

export default GenericGoogleSheetService;